// extracted by mini-css-extract-plugin
module.exports = {"portfolioItem":"ZFg93","projectItemHoverLayer":"_3L74W","siteName":"_5C2nZ","description":"_1LFUS","link":"_3ShsW","focused":"_10WZE","focusedNoLink":"_3aD5K","loader":"_2J3vc"};